import BulkSireneSyncButton from '@/producers/stores/components/BulkSireneSyncButton'
import DatagridStores from '@/producers/stores/components/listFields'
import {producerStoreExporter} from '@/producers/utils/exporters'
import {Alert, AlertTitle, Box} from '@mui/material'
import * as React from 'react'
import {Fragment, useEffect} from 'react'
import {AutocompleteArrayInput, BooleanInput, BulkDeleteButton, List, NumberInput, Pagination, ReferenceArrayInput, SearchInput, SelectInput, TextInput} from 'react-admin'

export default function ProducerStoreList() {
	return (
		<>
			<Alert severity="warning" style={{width: '100%', marginTop: 20}}>
				<AlertTitle>Attention à la hiérarchie des données !</AlertTitle>
				Les établissements <strong>sont les producteurs affichés sur la carte</strong> ; Ils doivent être reliés
				à une entreprise et
				plusieurs établissement (magasin, point de vente) peuvent donc appartenir à une même entreprise.
			</Alert>
			<List
				sort={{field: 'id', order: 'ASC'}}
				perPage={25}
				filters={[
					<SearchInput name="q" source="q" alwaysOn/>,
					<BooleanInput name="user_is_validated" source="user_is_validated" label="Compte validé"/>,
					<ReferenceArrayInput
						name="communes"
						label="Communes"
						reference="communes"
						source="communes"
					>
						<AutocompleteArrayInput
							optionText="name"
							optionValue="id"
							debounce={250}
						/>
					</ReferenceArrayInput>,
					<BooleanInput name="is_direct_selling" source="is_direct_selling" label="Vente directe"/>,
					<BooleanInput name="is_organic" source="is_organic" label="Bio"/>,
					<BooleanInput name="is_vad" source="is_vad" label="Vente à distance (VAD)"/>,
					<SelectInput 
						name="administrative_status" 
						source="administrative_status" 
						label="Statut SIRENE"
						choices={[
							{id: 'A', name: 'Actif'},
							{id: 'C', name: 'Cessée'}
						]}
					/>,
					<SelectInput 
						name="effectifs" 
						source="effectifs" 
						label="Effectifs"
						choices={[
							{id: 'NN', name: 'Non-employeur'},
							{id: '00', name: '0 salarié'},
							{id: '01', name: '1 à 2'},
							{id: '02', name: '3 à 5'},
							{id: '03', name: '6 à 9'},
							{id: '11', name: '10 à 19'},
							{id: '12', name: '20 à 49'},
							{id: '21', name: '50 à 99'},
							{id: '22', name: '100 à 199'},
							{id: '31', name: '200 à 249'},
							{id: '32', name: '250 à 499'},
							{id: '41', name: '500 à 999'},
							{id: '42', name: '1000 à 1999'},
							{id: '51', name: '2000 à 4999'},
							{id: '52', name: '5000 à 9999'},
							{id: '53', name: '10000+'}
						]}
					/>,
					<BooleanInput name="has_website" source="has_website" label="A un site internet"/>,
					<NumberInput name="producer.capital_social_min" source="producer.capital_social_min" label="Capital social min"/>,
					<NumberInput name="producer.capital_social_max" source="producer.capital_social_max" label="Capital social max"/>,
					<BooleanInput name="has_media" source="has_media" label="A des médias"/>
				]}
				exporter={producerStoreExporter}
			>
				<TableList/>
			</List>
		</>
	)
}

const TableList = () => {

	useEffect((): any => {
		document.title = 'Établissements | Producteurs'
	}, [])

	return (
		<Fragment>
			<Pagination rowsPerPageOptions={[5, 10, 25]}/>
			<DatagridStores
				optimized
				rowClick="edit"
				bulkActionButtons={<StoreBulkActions/>}
			/>
		</Fragment>
	)
}

const StoreBulkActions = () => (
	<Box display="flex" alignItems="center" gap={2}>
		<BulkSireneSyncButton/>
		<BulkDeleteButton/>
	</Box>
)
